/*
 * NutriProVita scroll reveal — App.tsx:436-444.
 *
 * Adds .is-in-view to .npv-reveal elements as they enter the viewport.
 * Deliberately NOT Sense's animations.js: that is gated on
 * settings.animations_reveal_on_scroll and keys off its own .scroll-trigger
 * contract. This is a small script with no dependency.
 *
 * .npv-reveal starts at opacity:0, so any element inserted AFTER load must also
 * be observed or it stays invisible forever. Sorting / filtering / pagination
 * (facets.js) and quick-add re-render the product grid via AJAX, so a
 * MutationObserver re-scans whenever nodes are added.
 *
 * npv-theme.css already forces .npv-reveal visible under
 * prefers-reduced-motion, so a non-firing observer never hides content.
 */
(function () {
  // Several sections include this file; run once per page.
  if (window.__npvReveal) return;
  window.__npvReveal = true;

  var obs = null;

  function reveal(el) {
    el.classList.add('is-in-view');
  }

  function run() {
    var els = document.querySelectorAll('.npv-reveal:not(.is-in-view)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    if (!obs) {
      obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
    }

    // observe() on an already-observed element is a no-op, so re-scanning is safe.
    els.forEach(function (el) {
      obs.observe(el);
    });
  }

  function watchForNewNodes() {
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        run();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    run();
    watchForNewNodes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-scan when a section is re-rendered.
  document.addEventListener('shopify:section:load', run);
})();
